import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Box,
  Checkbox,
  VStack,
} from "@chakra-ui/react";
import PrimaryButton from "../../../components/PrimaryButton";

const ShareWithDoctorModal = ({ isOpen, onClose, onSubmit }) => {
  const [selectedOptions, setSelectedOptions] = useState({
    shareToAll: false,
    email: false,
    // whatsApp: false,
    mediSupportApp: false,
  });

  const handleCheckboxChange = (option) => {
    if (option === "shareToAll") {
      setSelectedOptions({
        shareToAll: !selectedOptions.shareToAll,
        email: !selectedOptions.shareToAll,
        mediSupportApp: !selectedOptions.shareToAll,
      });
    } else {
      const newOptions = {
        ...selectedOptions,
        [option]: !selectedOptions[option],
      };

      // Auto-select shareToAll if both email and mediSupportApp are selected
      newOptions.shareToAll = newOptions.email && newOptions.mediSupportApp;

      setSelectedOptions(newOptions);
    }
  };

  const handleShare = () => {
    let notificationType;

    if (selectedOptions.shareToAll) {
      notificationType = "all";
    } else {
      const types = [];
      if (selectedOptions.email) types.push("email");
      if (selectedOptions.mediSupportApp) types.push("app");
      notificationType = types.join(",") || "all";
    }

    onSubmit({
      notificationType,
    });
    onClose();
  };

  // Add this function to check if any option is selected
  const isAnyOptionSelected = () => {
    return Object.values(selectedOptions).some((value) => value === true);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="primary.1" textAlign={"center"} fontSize={"2xl"}>
          Share With Doctor
        </ModalHeader>
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Box>
              <Checkbox
                isChecked={selectedOptions.shareToAll}
                onChange={() => handleCheckboxChange("shareToAll")}
              >
                Share To All
              </Checkbox>
            </Box>
            <Box>
              <Checkbox
                isChecked={selectedOptions.email}
                onChange={() => handleCheckboxChange("email")}
              >
                Email
              </Checkbox>
            </Box>
            {/* <Box>
              <Checkbox
                isChecked={selectedOptions.whatsApp}
                onChange={() => handleCheckboxChange("whatsApp")}
              >
                WhatsApp
              </Checkbox>
            </Box> */}
            <Box>
              <Checkbox
                isChecked={selectedOptions.mediSupportApp}
                onChange={() => handleCheckboxChange("mediSupportApp")}
              >
                MediSupport App
              </Checkbox>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <PrimaryButton
            mr={3}
            onClick={handleShare}
            isDisabled={!isAnyOptionSelected()}
          >
            Share
          </PrimaryButton>
          <Button colorScheme="red" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ShareWithDoctorModal;
